import { Download, Share, Smartphone, X } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export default function PWAInstallModal({
  appName,
  iconUrl,
  isIOS,
  isOpen,
  isPromptAvailable,
  onClose,
  onInstall,
}) {
  const description = isIOS
    ? "برای نصب، از منوی Share مرورگر گزینه Add to Home Screen را انتخاب کنید."
    : isPromptAvailable
      ? "اپ را نصب کنید تا سریع‌تر و با تجربه‌ای شبیه برنامه موبایل از آن استفاده کنید."
      : "مرورگر شما فعلا پرامپت نصب را ارائه نمی‌کند. می‌توانید از منوی مرورگر گزینه Install app را بزنید.";

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent dir="rtl" className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center justify-center gap-2 text-center">
            <Smartphone className="h-5 w-5 text-primary" />
            نصب {appName}
          </DialogTitle>
          <DialogDescription className="text-center leading-6">
            {description}
          </DialogDescription>
        </DialogHeader>

        <div className="flex flex-col items-center gap-4 py-2">
          <div className="flex h-20 w-20 items-center justify-center overflow-hidden rounded-2xl border bg-muted/30 p-2 shadow-sm">
            <img
              src={iconUrl}
              alt={appName}
              className="h-full w-full object-contain"
            />
          </div>

          <div className="text-center">
            <div className="text-base font-semibold">{appName}</div>
            <div className="mt-1 text-sm text-muted-foreground">
              {isIOS ? "قابل افزودن به صفحه اصلی" : "نصب نسخه وب اپلیکیشن"}
            </div>
          </div>

          {isIOS ? (
            <div className="w-full rounded-xl border bg-muted/20 p-3 text-sm leading-7 text-muted-foreground">
              <div className="flex items-center gap-2 font-medium text-foreground">
                <Share className="h-4 w-4" />
                راهنمای نصب در iPhone/iPad
              </div>
              <div className="mt-2">1. روی دکمه Share در Safari بزنید.</div>
              <div>2. گزینه Add to Home Screen را انتخاب کنید.</div>
              <div>3. روی Add بزنید.</div>
            </div>
          ) : null}
        </div>

        <DialogFooter className="flex-col gap-2 sm:flex-row">
          <Button variant="outline" onClick={onClose} className="w-full sm:w-auto">
            <X className="ml-2 h-4 w-4" />
            بستن
          </Button>
          <Button onClick={onInstall} disabled={!isIOS && !isPromptAvailable} className="w-full sm:w-auto">
            <Download className="ml-2 h-4 w-4" />
            {isIOS ? "متوجه شدم" : "نصب"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
